import { Chip, Divider, Grid, ListItemIcon, ListItemText, Menu, MenuItem, Rating, Skeleton, Toolbar, Typography } from "@mui/material";
import { ArrowBack, ArrowBackIos, ArrowForward, AutoFixHighSharp, ChevronRight, FilterSharp, Grade, Sort } from '@mui/icons-material';
import Navbar from "./Navbar";
import salon from './imgs/salon.avif';
import barber from './imgs/barber.avif';
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
import { use, useEffect, useRef, useState } from "react";
import axios from 'axios';
import { Geocoder } from "@mapbox/search-js-react";
import barberVideo from './vids/barbervid.mp4';
import Aos from "aos";
import NumberFlow from '@number-flow/react';
import { v4 as uuidv4 } from "uuid";
import Carousel from "react-multi-carousel";
import SalonSkeleton from "./components/SalonSkeleton";
import SalonCardLayout from "./components/SalonCardLayout";
// import { video } from './vids/barbervid.mp4';


// const invisibleBorderTheme = {
//   cssText: `
//     /* Targets the inner input field */
//     .Input {
//       border: none !important;
//       outline: none !important;
//       box-shadow: none !important;
//     }

//     /* Targets the outer wrapper container */
//     .SearchBox {
//       border: none !important;
//       box-shadow: none !important;
//     }
//   `
// };


const invisibleTheme = {
    variables: {
        // border: '1px solid black',
        boxShadow: 'none',
        // Ensures the focus state (the blue ring) is also cleared
        outline: 'none',
    },
    cssText: `
    /* Targets the specific SearchBox container */
    .SearchBox {
        
    }
    /* Targets the inner input where a secondary border often hides */
    .Input {
      border: 0 !important;
      box-shadow: none !important;
      outline: 0 !important;
      position:relative

    }
  `}
const themee = {
    variables: {
        border: 'none',
        boxShadow: 'none',
        // Ensures the focus state (the blue ring) is also cleared
        outline: 'none',
    },
    cssText: `
    /* Targets the specific SearchBox container */
    .SearchBox {
    }
    /* Targets the inner input where a secondary border often hides */
    .Input {
      border: 0 !important;
      box-shadow: none !important;
      outline: 0 !important;
      background white;
      position:relative

    }
  `
}

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3,
        slidesToSlide: 3 // optional, default to 1.
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
        slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
    }
};

export default function Home() {

    // const [useruuid, setuseruuid] = useState();
    // useEffect(() => {
    //     var uuid = localStorage.getItem('useruuid');
    //     if (!uuid) {
    //         var newuuid = uuidv4();
    //         localStorage.setItem('useruuid', newuuid);
    //         setuseruuid(newuuid);
    //     } else {
    //         setuseruuid(uuid);
    //     }
    // }, [])


    var navi = useNavigate();

    const [number, setNumber] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            const random = Math.floor(Math.random() * 3) + 1;
            setNumber(prev => prev + random);
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    const [cities, setcities] = useState(['Chandigarh', 'Panchkula', 'Sahibzada Ajit Singh Nagar'])

    const [addresses, setaddresses] = useState([
        { PlaceName: 'Chandigarh', Address: 'Sector-17, Chandigarh' },
        { PlaceName: 'Mohali', Address: 'Sector-82, Sahibzada Ajit Singh(SAS) Nagar' },
        { PlaceName: 'Panchkula', Address: 'Housing Board, Panchkula' }
    ]);

    const [chosenaddress, setchosen] = useState('Sector-17, Chandigarh');
    function pickrandom() {
        var random = Math.floor(Math.random() * 3);
        setchosen(addresses[random].Address);
    }
    useEffect(() => {
        pickrandom();
    }, [])

    const [lat, setlat] = useState(null);
    const [long, setlong] = useState(null);

    useEffect(() => {
        var lat = sessionStorage.getItem('Lat');
        var long = sessionStorage.getItem('Long');
        if (lat && long) {
            getShops(lat, long);
            getRecentlyVisitedShops(lat, long)
            getTrendingPlaces(lat, long)
            setlat(lat);
            setlong(long);
            // console.log('already fetched');
        } else {
            getLatLong();
            // console.log('fetching')
        }

    }, [])

    function getLatLong() {
        // console.log('Start')
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;

                sessionStorage.setItem('Lat', latitude);
                sessionStorage.setItem('Long', longitude);

                console.log(latitude, longitude);
                setlat(latitude);
                setlong(longitude);
                getShops(latitude, longitude)
                getRecentlyVisitedShops(latitude, longitude);
                getTrendingPlaces(latitude, longitude)
            },
            (error) => {
                console.error("Location access denied", error);
            }
        );
    }
    // useEffect(() => {
    //     getLatLong();
    // }, [])

    var url = `http://${process.env.PORT || 3000}/`
    const [shops, setshops] = useState([]);

    const [filters, setFilters] = useState({
        sortBy: "",
        gender: "any",
        // price: "",
    });

    const [sortPriority, setSortPriority] = useState(["rating", "distance"])

    useEffect(() => {
        console.log(filters.gender)
    }, [filters])

    const [storedShops, setStoredShops] = useState([]);

    const [loaded, setLoaded] = useState({
        nearby: false,
        trending: false,
        recently: false
    });

    function getShops(x, y) {
        // if (lat == 0 || long == 0) {

        // } else {
        axios.post(url + 'getShops', {
            CLat: x,
            CLong: y
        }).then((succ) => {
            if (succ.data == 'erorr') {
                alert('erorr')
            } else {
                console.log(succ.data);
                setshops(succ.data);
                setStoredShops(succ.data);
                setLoaded(prev => ({
                    ...prev,
                    nearby: true
                }))
            }
        })
        // }
    }

    useEffect(() => {
        const compare = {
            rating: (a, b) => (b.AvgRating?.toFixed(1) || 0) - (a.AvgRating?.toFixed(1) || 0),
            distance: (a, b) => (a.distance || Infinity) - (b.distance || Infinity),
        }

        let result = [...storedShops];
        if (filters.sortBy != '') {
            result.sort((a, b) => {
                for (const row of sortPriority) {
                    const single_result = compare[row](a, b)

                    if (single_result != 0) {
                        return single_result
                    }
                }
                return 0;
            })
        }
        if (filters.gender != '' && filters.gender != 'any') {
            result = result.filter(salon => salon.Gender?.toLowerCase() === filters.gender.toLowerCase());
        }

        setshops(result);

    }, [filters, storedShops, sortPriority])
    useEffect(() => {
        console.log("Filters!!!!!!!!!", filters);
    }, [filters])

    const [pos, setpos] = useState('sticky');
    const [show, setshow] = useState(false)

    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        const position = Math.ceil(
            (scrollTop / (scrollHeight - clientHeight) * 100)
        );
        if (position >= 17) {
            setpos('sticky')
            setshow(true)
        } else {
            setshow(false)
        }
    }

    Aos.init();

    const [reviews, setreviews] = useState([
        { Name: 'Naksh Sharma', Review: 'Dolore et pariatur culpa ex in in tempor proident commodo quis nisi Lorem id et. Incididunt dolore eu aliquip sunt eu mollit et ad esse aliquip est nisi pariatur. Consectetur velit proident aute do duis dolor consequat quis cillum nulla est. Id anim et ipsum dolor.' },
        { Name: 'Levy Rozman', Review: 'Occaecat Lorem velit qui sint. Deserunt dolor in in deserunt occaecat excepteur consequat irure. Cupidatat ex exercitation voluptate officia ipsum adipisicing laboris sit sint. In magna quis irure eiusmod elit.', },
        { Name: 'Lucy Rozman', Review: 'Deserunt consequat qui ullamco sint Lorem sint quis elit veniam. Exercitation Lorem nisi deserunt adipisicing quis sint do occaecat duis culpa officia cillum aliquip. Proident nisi adipisicing commodo non.', },
        { Name: 'Dan Stayne', Review: 'Qui magna laborum aliqua minim ipsum proident minim fugiat cupidatat do minim dolor. Laborum laboris nulla qui id laborum. Velit et ullamco excepteur ut laborum anim id. Ullamco sunt incididunt nulla do ' },
        { Name: 'Naksh Sharma', Review: 'Dolore et pariatur culpa ex in in tempor proident commodo quis nisi Lorem id et. Incididunt dolore eu aliquip sunt eu mollit et ad esse aliquip est nisi pariatur. Consectetur velit proident aute do duis dolor consequat quis cillum nulla est. Id anim et ipsum dolor.' },
        { Name: 'Levy Rozman', Review: 'Occaecat Lorem velit qui sint. Deserunt dolor in in deserunt occaecat excepteur consequat irure. Cupidatat ex exercitation voluptate officia ipsum adipisicing laboris sit sint. In magna quis irure eiusmod elit.', },
        { Name: 'Lucy Rozman', Review: 'Deserunt consequat qui ullamco sint Lorem sint quis elit veniam. Exercitation Lorem nisi deserunt adipisicing quis sint do occaecat duis culpa officia cillum aliquip. Proident nisi adipisicing commodo non ipsum anim ullamco officia. Exercitation do voluptate fugiat excepteur elit labore sunt elit adipisicing dolor.', },
        { Name: 'Dan Stayne', Review: 'Qui magna laborum aliqua minim ipsum proident minim fugiat cupidatat do minim dolor. Laborum laboris nulla qui id laborum. Velit et ullamco excepteur ut laborum anim id. Ullamco sunt incididunt nulla do adipisicing est ipsum commodo.' },
    ]);

    // Hair cut
    // Beard Styling / Shave
    //     Facial
    //     Cleansing
    //     Scrubbing
    // Detan Treament
    // Head Massage
    // Neck Massage
    // Shoulder Massage
    // Hair Coloring
    //     Pedicures
    //     Manicures
    // Body Waxing

    const [services, setservices] = useState([
        { Color: '#E8AE28', Name: 'Hair cut', Image: 'https://png.pngtree.com/png-clipart/20250213/original/pngtree-new-style-man-hair-cutting-transfarent-background-png-image_20426260.png' },
        { Color: '#475DFF', Name: 'Facial', Image: "https://www.naturals.in/services/skin/assets/face_cleanup/sc_woman.png" },
        { Color: '#E850C7', Name: 'Body Waxing', Image: "https://topone.co.uk/wp-content/uploads/2021/05/waxing.png" },
        { Color: '#157983', Name: 'Hair Colouring', Image: "https://topone.co.uk/wp-content/uploads/2021/05/waxing.png" },
        { Color: '#BD5C25', Name: 'Pedicure', Image: "https://png.pngtree.com/png-clipart/20241225/original/pngtree-spa-hands-pedicure-bloom-photo-png-image_18195351.png" },
        // { Color:'',Name: 'Scrubbing', Image: "https://png.pngtree.com/png-vector/20240927/ourmid/pngtree-young-woman-applying-face-scrub-woman-cosmetic-skin-png-image_13934261.png" },
        { Color: '#799C26', Name: 'View All', Image: 'https://png.pngtree.com/png-vector/20240927/ourmid/pngtree-young-woman-applying-face-scrub-woman-cosmetic-skin-png-image_13934261.png' }
    ])

    const [brands, setbrands] = useState([
        { Color: '#E8AE28', Name: 'VLCC', Icon: 'https://vavodigital.com/wp-content/uploads/2021/05/vlcc-colour-logo.png' },
        { Color: '#475DFF', Name: 'Colorbar', Icon: 'https://rcity.in/rcity-admin/brand_logo/colorbar.png' },
        { Color: '#E850C7', Name: "L'Oréal", Icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/L%27Or%C3%A9al_logo.svg/1280px-L%27Or%C3%A9al_logo.svg.png' },
        { Color: '#157983', Name: 'Bblunt', Icon: 'https://inrdeals.sgp1.cdn.digitaloceanspaces.com/production/426102/bblunt-logo.png' },
        { Color: '#BD5C25', Name: 'Lakmē', Icon: 'https://1000logos.net/wp-content/uploads/2020/04/Lakme-Logo-2011.png' },
        { Color: '#799C26', Name: 'RICA', Icon: 'https://auradistribution.ca/wp-content/uploads/2024/01/Logos_site_web_Rica-500x206.png' },
    ]);

    const [recentlyVisited, setrecentlyVisited] = useState([]);
    function getRecentlyVisitedShops(x, y) {
        // console.log('start')
        var ids = localStorage.getItem('ids');

        console.log(JSON.parse(ids));
        if (JSON.parse(ids)) {
            var data = JSON.parse(ids);
            axios.post(url + 'getRecentlyVisited', {
                Ids: data,
                CLong: Number(y),
                CLat: Number(x)
            }).then((succ) => {
                setrecentlyVisited(succ.data);
                setLoaded((prev) => ({
                    ...prev,
                    recently: true
                }))
                // console.log('Shops' + succ.data)
            })
            // setrecentlyVisited(data);
        } else {
            console.log('no ids ')
        }

    }
    const [trendingPlaces, setTrendingPlaces] = useState([]);
    function getTrendingPlaces(x, y) {
        // if () {
        console.log('start fetching trending places');
        axios.post(url + 'getTrendingPlaces', {
            userLat: x,
            userLng: y
        }).then((succ) => {
            // console.log( "UserData!!!!!!!!",succ.data)
            if (succ.data.response == 'success') {
                setTrendingPlaces(succ.data.shops)
                setLoaded((prev) => ({
                    ...prev,
                    trending: true
                }))
            } else {
                alert(succ.data.reason);
            }
        })
        // }
    }
    function createSlug(name) {
        return name
            .toLowerCase()
            .trim()
            .replace(/\s+/g, "-")
            .replace(/[^\w\-]+/g, "");
    }
    function gotoNextPage(id, name) {
        // console.log('start')
        // var ids = localStorage.getItem('ids');
        // const data = JSON.parse(ids);
        // // console.log(ids)
        // if (ids) {
        //     if (data.indexOf(id) == -1) {
        //         // navi('/Barber?id=' + id);
        //         // axios.post(url + 'viewShop', {
        //         //     Id: id,
        //         // }).then((succ) => {
        //         //     if (succ.data.result == 'success') {
        //         //         var data = JSON.parse(ids);
        //         //         console.log(data)
        //         //         console.log('done')
        //         //         navi('/Barber?id=' + id);
        //         //     } else {
        //         //         console.log('not')
        //         //     }

        //         // })
        //         data.push(id);
        //         localStorage.setItem('ids', JSON.stringify(data));
        //     }
        //     //  else {
        //     // navi('/Barber?id=' + id);
        //     // }

        // } else {
        //     var idCont = []
        //     idCont.push(id)
        //     localStorage.setItem('ids', JSON.stringify(idCont));
        //     // navi('/Barber?id=' + id);
        // }
        // axios.post(url + 'viewShop', {
        //     Id: id,
        // }).then((succ) => {
        //     if (succ.data.result == 'success') {
        //         var data = JSON.parse(ids);
        //         // console.log(data)
        //         // console.log('done')
        //         navi(`/Barber/${createSlug(name)}-${id}`);
        //     } else {
        //         // console.log('not')
        //     }

        // })
        let ids = localStorage.getItem('ids');

        let data = ids ? JSON.parse(ids) : [];

        if (!data.includes(id)) {
            data.push(id);
            localStorage.setItem('ids', JSON.stringify(data));
        }

        axios.post(url + 'viewShop', {
            Id: id,
        }).then((succ) => {

            if (succ.data.result === 'success') {

                navi(
                    `/Barber/${createSlug(name)}-${id}`
                );

            }

        });
    }

    const [searchCredentials, setSearchCredentials] = useState(null);


    // ; (() => {

    // }, [])

    function searchforplace() {
        if (!searchCredentials) {
            return;
        }
        var data = searchCredentials;
        navi(`/search?address=${data.name.toLowerCase().trim().replace(/\s+/g, "-").replace(/[^\w\-]+/g, "")}&lat=${data.lat}&lon=${data.lon}`);
    }
    useEffect(() => {
        console.log("STATE UPDATED:", searchCredentials);
    }, [searchCredentials]);

    const [data, setdata] = useState();
    const [headings, setheadings] = useState([]);
    function fetch() {
        // axios.post(url + 'fetchHeadings', {
        //     PageName: 'Home'
        // }).then((succ) => {
        //     setdata(succ.data);
        //     setheadings(succ.data.Headings)
        //     // console.log(succ.data.Headings[0].content);
        // })
    }

    useEffect(() => {
        fetch();
    }, [])

    const [categories, setCategories] = useState([]);
    async function fetchCategories() {
        try {

            const response = await axios.post(url + 'admin/categories/fetch');

            if (response.data.response === "success") {
                setCategories(response.data.data || []);
                console.log(response.data.data);
            } else {
                alert(response.data.reason);
            }
        } catch (error) {
            console.log("Fetch Categories Error!!!!:", error);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    const uuid = localStorage.getItem('uuid');

    const [isVisible, setIsVisible] = useState(true);
    const targetRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            // console.log(entry.isIntersecting);
            setIsVisible(entry.isIntersecting);
        });

        if (targetRef.current) {
            // console.log("Observing:", targetRef.current);
            observer.observe(targetRef.current);
        }

        return () => observer.disconnect();
    }, []);
    // useEffect(() => {
    //     console.log(isVisible);
    // }, [isVisible]);


    const [anchorEl, setAnchorEl] = useState(null);
    const [genderAnchor, setGenderAnchor] = useState(null);

    const open = Boolean(anchorEl);

    // console.log(anchorEl, open);

    return (
        <>
            {/* <div onScroll={handleScroll}> */}
            <Grid position={'sticky'} top={'0px'} zIndex={5}>
                <Grid container justifyContent={'space-between'} alignItems={'center'} px={1.5} bgcolor={'#069CD0'} className='navbar'>
                    {/* <Toolbar> */}
                    <Typography variant="h5" fontWeight={'bold'} fontFamily={'RoobertPRO'} color="white">BookYourSalon</Typography>
                    {/* <Grid flexGrow={1}></Grid> */}
                    {show && (
                        <Grid className='input-cont-cont2  poss '>
                            <Grid className='input-contt2 poss'>
                                <Geocoder onChange={(feature) => {
                                    // const [lat, long] = feature.center;
                                    // const [lat, long] = feature.center;
                                    const [lon, lat] = feature.center;
                                    setSearchCredentials({
                                        name: feature.place_name,
                                        lat: lat,
                                        lon: lon
                                    });
                                    console.log("Selected:", feature.place_name);
                                    console.log("Lat:", lat);
                                    console.log("Lon:", lon);
                                }} placeholder={chosenaddress + ' etc.'} theme={themee} accessToken={process.env.MAPBOX} options={{ language: 'en', country: 'In' }} />
                            </Grid>
                            <button onClick={() => searchforplace()} className="btn-cus-navy2">Search</button>
                        </Grid>
                    )}
                    {!show && (
                        <div>
                            <button onClick={() => navi('/List')} className="btn btn-navy">
                                <Typography fontSize={15}>List your business</Typography>
                            </button>
                            <button onClick={() => navi('/SignUp')} className="btn ms-2 btn-navy">
                                <Typography fontSize={15}>Sign In</Typography>
                            </button>
                        </div>
                    )}
                    {/* </Toolbar>/ */}
                </Grid>
                {!isVisible && (
                    <div className="bg-dark text-white fadeInTop w-100 px-3 py-2">
                        <Chip onClick={(e) => setAnchorEl(e.currentTarget)} label={'Sort'} icon={<Sort />} clickable size="small" className='bg-white' />
                    </div>
                )}
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={() => {
                        setAnchorEl(null);
                        setGenderAnchor(null);
                    }}
                >
                    <MenuItem onClick={() => (
                        setSortPriority(["rating", "distance"]),
                        setFilters(prev => ({
                            ...prev,
                            sortBy: "rating"
                        }))
                    )}>Rating</MenuItem>

                    <MenuItem onClick={() => (
                        setSortPriority(["distance", "rating"]),
                        setFilters(prev => ({
                            ...prev,
                            sortBy: "distance"
                        }))
                    )}>Distance</MenuItem>

                    <MenuItem
                        onMouseEnter={(e) => setGenderAnchor(e.currentTarget)}
                    >
                        <ListItemText>Gender</ListItemText>
                        <ListItemIcon sx={{ justifyContent: "flex-end" }}>
                            <ChevronRight />
                        </ListItemIcon>
                    </MenuItem>

                    <MenuItem>Price</MenuItem>

                    <MenuItem>Reviews</MenuItem>
                </Menu>

                {/* Sub Menu */}
                <Menu
                    anchorEl={genderAnchor}
                    open={Boolean(genderAnchor)}
                    onClose={() => setGenderAnchor(null)}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "left"
                    }}
                >
                    <MenuItem onClick={() => {
                        setFilters(prev => ({
                            ...prev,
                            gender: "male"
                        }));

                        setAnchorEl(null);
                        setGenderAnchor(null);
                    }}>Male</MenuItem>
                    <MenuItem onClick={() => {
                        setFilters(prev => ({
                            ...prev,
                            gender: "female"
                        }));

                        setAnchorEl(null);
                        setGenderAnchor(null);
                    }}> Female </MenuItem>
                    <MenuItem onClick={() => {
                        setFilters(prev => ({
                            ...prev,
                            gender: "both"
                        }));

                        setAnchorEl(null);
                        setGenderAnchor(null);
                    }}>Both</MenuItem>
                    <MenuItem onClick={() => {
                        setFilters(prev => ({
                            ...prev,
                            gender: "any"
                        }));

                        setAnchorEl(null);
                        setGenderAnchor(null);
                    }}>Any</MenuItem>
                </Menu>
            </Grid>
            <Grid className='home-section'>
                <Grid container position={'relative'} className='text-cont' >
                    <Grid size={{ xs: 12, lg: 6 }} className='header px-3 ms-lg-5'>
                        <Typography data-aos='fade-right' data-aos-duration="2000" variant="h1" className="heading-text" fontWeight={headings[0]?.fontweight || 'bold'} fontFamily={'Monotype Corsiva'}>{headings[0]?.content || 'Your Hair,  but Better'}</Typography>
                        <button className="btn btn-dark" onClick={() => {
                            window.location.href = `http://localhost:1000/google/login?salonId=${uuid}`
                        }}>Submit</button>
                        <Typography data-aos='fade-right' fontWeight={headings[1]?.fontweight || 'normal'} data-aos-duration="2000" className="mt-lg-3" variant="h6">
                            {headings[1]?.content || 'Find your nearest salon'}
                        </Typography>
                        <Grid data-aos='fade right' data-aos-duration='3000' className='input-cont-cont px-2 mt-3'>
                            <div ref={targetRef} className='input-contt'>
                                {/* <Geocoder
                                        onRetrieve={(res) => {

                                            console.log("RAW RESULT:", res);

                                            if (!res.suggestions || res.suggestions.length === 0) {
                                                console.log("No suggestions found");
                                                return;
                                            }

                                            const feature = res.suggestions[0];

                                            const [lon, lat] = feature.geometry.coordinates;

                                            const locationData = {
                                                name: feature.properties.full_address,
                                                lat: lat,
                                                lon: lon
                                            };

                                            console.log("Saving location:", locationData);

                                            setSearchCredentials(locationData);
                                            // await 
                                        }}

                                        placeholder={chosenaddress + ' etc.'}
                                        theme={invisibleTheme}
                                        accessToken={'pk.eyJ1IjoibmFrc2hzaGFybWEiLCJhIjoiY21sMTdlNmZmMDR3bTNlc2FubmRveWE1ciJ9.FUCHDeqJcf1GrgdiPTIRiQ'}
                                        options={{
                                            language: 'en',
                                            country: 'IN'
                                        }}
                                    /> */}
                                <Geocoder
                                    onRetrieve={(res) => {

                                        // console.log("RAW RESULT:", res);

                                        // For @mapbox/search-js-react
                                        if (!res) {
                                            console.log("No result received");
                                            return;
                                        }

                                        const locationData = {
                                            lat: res.properties.coordinates.latitude,
                                            lon: res.properties.coordinates.longitude,
                                            name: res.properties.place_formatted
                                        };

                                        // console.log("Saving location:", locationData);

                                        setSearchCredentials(locationData);
                                    }}

                                    placeholder={chosenaddress + ' etc.'}
                                    theme={invisibleTheme}
                                    accessToken={'pk.eyJ1IjoibmFrc2hzaGFybWEiLCJhIjoiY21sMTdlNmZmMDR3bTNlc2FubmRveWE1ciJ9.FUCHDeqJcf1GrgdiPTIRiQ'}

                                    options={{
                                        language: 'en',
                                        country: 'IN'
                                    }}
                                />
                            </div>
                            <button className="btn-cus-navy" onClick={searchforplace}>Search</button>
                        </Grid>
                        {/* <br /> */}
                        {/* <br /> */}
                        {/* <Typography variant="h5" className="mt-2" textAlign={'center'}> */}
                        {/* <NumberFlow value={number} className="appointments" /> */}
                        {/* &nbsp;Visits Today */}
                        {/* </Typography> */}
                    </Grid>
                    <Grid size={{ lg: 6 }}>
                        <img data-aos='fade-left' data-aos-duration="3500" src="https://html.nextwpcook.com/barbex/assets/img/bg/banner-1.png" className=" position-img" />
                    </Grid>
                </Grid>
            </Grid>
            <Grid width={'95%'} margin={'auto'}>

                <Typography py={4} variant="h4">{headings[2]?.content || 'Nearby Salons'} </Typography>
                <Grid margin={'auto'}>

                    <Grid className="slider-cont mx-auto">
                        {loaded.nearby ? (
                            shops.length > 0 && (
                                shops.map((row) => (
                                    <SalonCardLayout data={row} />
                                ))
                            )
                        ) : (
                            <SalonSkeleton />
                        )}
                    </Grid>
                </Grid>
                {/* {recentlyVisited && ( */}

                {/* recentlyVisited.length > 0 && ( */}
                {/* <> */}
                <Typography py={4} fontFamily={''} variant="h4">{headings[3]?.content || 'Recently Visited'}</Typography>
                <Grid marginInline={'auto'}>
                    <div className="mx-auto slider-cont">
                        {loaded.recently ? recentlyVisited?.map((row) => (
                            <SalonCardLayout data={row} />
                        )) : (
                            <SalonSkeleton />
                        )}
                    </div>
                </Grid>
                {/* </> */}
                {/* ) */}

                {/* )} */}
                <Typography py={4} variant="h4">{headings[4]?.content || 'Trending Nearby'}</Typography>
                <Grid marginInline={'auto'}>
                    {/* <Slider autoplay autoplaySpeed={2500} className="slider-cont mx-auto" useCSS infinite={true} dots={false} swipe speed={500} slidesToShow={4} slidesToScroll={4}> */}
                    <div className="mx-auto slider-cont">
                        {loaded.trending ? (
                            trendingPlaces?.map((row) => (
                                <SalonCardLayout data={row} />
                            ))
                        ) : (
                            <SalonSkeleton />
                        )}
                    </div>
                </Grid>
                {/* <br /> */}
            </Grid>
            <video
                src={barberVideo}
                autoPlay
                muted
                loop
                playsInline
                className="video-bg mt-4"
            />

            <Grid width={'90%'} marginInline={'auto'}>
                <Typography py={4} variant="h4">{headings[5]?.content || 'Explore Our Services'}</Typography>
                <Grid className='service_grid'>
                    {categories.map((row, index) => (

                        <Grid onClick={() => navi(`/service?service=${row?.Name?.toLowerCase().trim().replace(/\s+/g, "-").replace(/[^\w\-]+/g, "")}&lat=${lat}&lon=${long}`)} bgcolor={index == 0 ? '#E8AE28' : index == 1 ? "#475DFF" : index == 2 ? "#E850C7" : index == 3 ? "#157983" : index == 4 ? "#BD5C25" : "#799C26"} p={2} borderRadius={2} className='service-item overflow-hidden text-white'>
                            <Typography variant="h6">{row.Name}</Typography>
                            <img src={row.Image} className="serviceImg" />
                        </Grid>
                    ))}
                </Grid>
                <Typography py={4} variant="h4">{headings[6]?.content || 'Top Brands For You'}</Typography>
                <Grid className='service_grid'>
                    {/* <br /> */}
                    {brands.map((row) => (
                        <Grid className='brands' paddingBlock={4} paddingInline={2}>
                            {/* <Typography variant="h5">{row.Name}</Typography> */}
                            <img src={row.Icon} className="img-fluid" />
                        </Grid>
                    ))}
                </Grid>
            </Grid>

            {/* Download The App Section*/}
            {/* Download The App Section*/}
            {/* Download The App Section*/}

            <Grid container alignItems={'center'} className='text-center bg-navy  py-4 px-4 app' color={'white'} justifyContent={'center'} mt={8}>
                <Grid size={{ lg: 4 }}>
                    <Typography className="h-3" color="black" fontWeight={'bold'}>{headings[7]?.content || 'Download The App'}</Typography>
                    <Typography className="mt-1 h-5">Book your slot according to your availablitity</Typography>
                    <div className="d-flex mt-3 justify-content-between position-relative zIndex">
                        <button className="btn col-6">
                            <img src="https://cdn.prod.website-files.com/642703f0c82fbfaaa2f8d81b/642703f0c82fbf6c64f8d823_download.svg" className="img-fluid" />
                        </button>
                        <button className="btn col-6">
                            <img src="https://parkmate.co.nz/wp-content/uploads/2020/07/Asset-10.png" className="img-fluid" />
                        </button>
                    </div>
                </Grid>
                <Grid size={{ lg: 1.5 }}></Grid>
                <img src="https://cdn.prod.website-files.com/642703f0c82fbfaaa2f8d81b/6481aad5a664682e7e8d1d2c_phone2-pound.webp" className="imgOne " />
            </Grid>
            <svg width="100%" id="svg" viewBox="0 0 1440 390" xmlns="http://www.w3.org/2000/svg" class="transition duration-300 ease-in-out delay-150"><path d="M 0,400 L 0,150 C 126.26666666666671,106.53333333333333 252.53333333333342,63.06666666666668 439,87 C 625.4666666666666,110.93333333333332 872.1333333333334,202.26666666666668 1049,224 C 1225.8666666666666,245.73333333333332 1332.9333333333334,197.86666666666667 1440,150 L 1440,400 L 0,400 Z" stroke="none" stroke-width="0" fill="#C1E9F6" fill-opacity="1" class="transition-all duration-300 ease-in-out delay-150 path-0" transform="rotate(-180 720 200)"></path></svg>

            <Grid width={'90%'} margin={'auto'}>
                <Typography variant="h4" py={5}>{headings[8]?.content || 'Reviews'}</Typography>
                <Carousel className="overflow-hidden" responsive={responsive} draggable={true} keyBoardControl={true} showDots={false} autoPlay={false} autoPlaySpeed={2000}>

                    {reviews.map((row, index) => (
                        <>
                            {/* <Grid className={index == 3 || index == 7 ? "animate1" : index == 0 || index == 4 ? "animate2" : index == 1 || index == 5 ? 'animate3' : 'animate4'} bgcolor={'#E0E0E0'} borderRadius={1} p={2.5}> */}
                            <Grid bgcolor={'#C1E9F6'} className={index == 0 ? 'scrollableItem' : 'scrollableItem ms-3'} py={3} borderRadius={1} p={2.5}>
                                <div className="d-flex align-items-center justify-content-between">
                                    <Typography variant="h6">{row.Name}</Typography>
                                    <Rating value={4.5} precision={.5} readOnly />
                                </div>
                                <Typography variant="body1" className="mt-3">{row.Review}</Typography>
                            </Grid>
                        </>
                    ))}
                </Carousel>
            </Grid>

            {/* <Grid width={'90%'} margin={'auto'}>
                        <Grid width={'100%'} className='pb-5' >
                            <Typography variant="h4" >{headings[9]?.content || 'Browse By City'}</Typography>
                            <div className="w-100 mt-3 overfloww">
                                {cities.map((row) => (
                                    <button className="btn-hover border-0 bg-transparent ms-1 rounded-pill py-1 px-3">{row}</button>
                                ))}
                            </div>
                        </Grid>
                    </Grid> */}
            {/* <br /> */}
            {/* <br /> */}
            <Footer />
            {/* </Grid > */}
            {/* </div> */}
        </>
    )

}